import './services/appInsights';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

// Expose for E2E test harness so Playwright can acquire a token against the
// already-initialized instance. MSAL v4 encrypts localStorage, so reading
// tokens directly from storage isn't possible.
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.__msalInstance = msalInstance;
}

msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
